import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const  resource = "/landlord/roles";
export default {
  getChannelPartnerList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort, tenant_id) {
    if(tenant_id) return Repository.get(`/landlord/tenant/${tenant_id}/channel-partners?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`) 
    return Repository.get(`/landlord/marketing/channel-partners?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getListNoPagination() {
    return Repository.get(`${resource}?is_paginate=0`)
  },
  getChannelPartnerCustomers(resource_id, pageNumber = 1, pagination = defaultPagination, tenant_id) {
    if(tenant_id) return Repository.get(`/landlord/tenant/${tenant_id}/channel-partners/${resource_id}?paginate=${pagination}&page=${pageNumber}`)
    return Repository.get(`/landlord/marketing/channel-partners/${resource_id}/partner-customers?paginate=${pagination}&page=${pageNumber}`)
  },
  getChannelPartner(resource_id) {
    return Repository.get(`/landlord/marketing/channel-partners/${resource_id}`)
  },
  // updateChannelPartner(tenant_id, resource_id, payload) {
  //   return Repository.put(`/landlord/tenant/${tenant_id}/channel-partners/${resource_id}`, payload)
  // },
  updateChannelPartner(resource_id, payload) {
    return Repository.put(`/landlord/marketing/channel-partners/${resource_id}`, payload)
  },
  createChannelPartner(payload, tenant_id) {
    if(tenant_id) return Repository.post(`/landlord/tenant/${tenant_id}/channel-partners`, [ payload ])
    return Repository.post(`/landlord/marketing/channel-partners`, payload)
  },
  createChannelPartnerAgreement(resource_id, payload) {
    return Repository.post(`/landlord/marketing/channel-partners/${resource_id}/partner-customers`, payload)
  },
  getCustomerAgreements(customer_id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`/landlord/marketing/partner-customers/${customer_id}/agreements?paginate=${pagination}&page=${pageNumber}`)
  },
  createChannelPartnerCustomerAndAgreement(partner_id, payload) {
    return Repository.post(`/landlord/marketing/channel-partners/${partner_id}/partner-customers`, payload)
  },
  cretaeChannelPartnerAgreemen(customer_id, payload) {
    return Repository.post(`/landlord/marketing/partner-customers/${customer_id}/agreements`, payload)
  },
  sendWelcomeEmail(email, status) {
    return Repository.put(`/landlord/marketing/channel-partner/${status}`, { email})
  },
  changeAgreementStatus(id, status) {
    return Repository.put(`/landlord/marketing/channel-partner/agreement/${id}/status`, { status })
  },
  changePartnerStatus(id, status) {
    return Repository.put(`/landlord/marketing/channel-partner/${id}/status`, { status })
  },

  // agreement template apis
  getListOfAgreementTemplates(partner_id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`/landlord/marketing/channel-partners/${partner_id}/agreement-templates?paginate=${pagination}&page=${pageNumber}`)
  },
  createAgreementTemplate(partner_id, payload) {
    return Repository.post(`/landlord/marketing/channel-partners/${partner_id}/agreement-templates`, payload)
  },
  updateAgreementTemplate(template_id) {
    return Repository.put(`/landlord/marketing/agreement-templates/${template_id}`, payload)
  },
  deleteAgreementTemplate(template_id) {
    return Repository.delete(`/landlord/marketing/agreement-templates/${template_id}`)
  },
  getAvailableTenantsForPartners(is_paginate = 0) {
    return Repository.get(`/landlord/marketing/channel-partner/customer-list?is_paginate=${is_paginate}`)
  },

  //paerner users
  getChannelPartnerUsers(partner_id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/landlord/marketing/channel-partners/${partner_id}/channel-partner-users?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`) 
  },
  sendUsersWelcomeEmail(id, status) {
    return Repository.put(`/landlord/marketing/channel-partner-user/${id}/${status}`)
  },
  changePartnerUserStatus(id, status) {
    return Repository.put(`/landlord/marketing/channel-partner-user/${id}/status`, { status })
  },
  createChannelPartnerUser(id, payload) {
    return Repository.post(`/landlord/marketing/channel-partners/${id}/channel-partner-users`, payload)
  },
  deployeDemoTenant(id) {
    return Repository.post(`/landlord/marketing/channel-partner/${id}/deploy`)
  },
  getDemoPortalToken(id) {
    return Repository.get(`/landlord/marketing/channel-partner/${id}/get-demo-tenant-token`)
  }
};
